import React, { memo } from 'react';
export const HonestQuestion = memo(function HonestQuestion() {
  const problems = [{
    icon: '📱',
    text: 'Te despertás y antes de abrir un ojo ya tenés el celular en la mano. Dos horas después, tu energía mental está en cero y el día todavía no empezó.'
  }, {
    icon: '💸',
    text: 'Sabés exactamente cuánto dinero perdiste por no ejecutar tus proyectos, pero el algoritmo sigue siendo más fuerte que tu voluntad.'
  }, {
    icon: '😤',
    text: 'Tenés el talento y las ideas, pero otro año está pasando sin que ninguna de ellas se materialice. El celular te tiene más a vos que vos a él.'
  }, {
    icon: '⏳',
    text: 'Prometiste mil veces que ibas a cambiar. El lunes. El mes que viene. Cuando tengas tiempo. Y el ciclo de culpa se repite cada noche.'
  }];
  return <section className="py-12 px-4 bg-gray-50 border-t border-gray-200" data-id="element-73">
      <div className="max-w-2xl mx-auto" data-id="element-74">
        {/* PROBLEMA */}
        <h2 className="text-[22px] md:text-3xl font-black text-gray-900 leading-tight text-center mb-6" data-id="element-75">
          La realidad que nadie dice en voz alta{' '}
          <span className="text-yellow-500" data-id="element-76">pero todos vivimos.</span>
        </h2>

        <div className="space-y-3 mb-6" data-id="element-77">
          {problems.map((p, i) => <div key={i} className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 shadow-sm" data-id="element-78">
              <span className="text-2xl flex-shrink-0" data-id="element-79">{p.icon}</span>
              <p className="text-gray-900 font-bold text-[14px] md:text-base leading-snug" data-id="element-80">
                {p.text}
              </p>
            </div>)}
        </div>

        {/* PUENTE + SOLUCIÓN */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl px-5 py-6 text-center shadow-sm" data-id="element-81">
          <div className="inline-block px-4 py-1 rounded-full font-bold text-xs mb-3 text-yellow-600 bg-yellow-100 border border-yellow-200 uppercase tracking-widest" data-id="element-82">
            🧠 La Solución
          </div>
          <h3 className="text-[20px] md:text-3xl font-black text-yellow-500 mb-2" data-id="element-83">
            MEGAPACK DOMINA TU MENTE
          </h3>
          <p className="text-gray-700 font-bold text-[13px] md:text-base leading-snug mb-4" data-id="element-84">
            El sistema completo para resetear tu dopamina y recuperar el control
            de tu atención desde hoy. Ejecutá tus proyectos con foco real y
            convertí tu potencial en resultados concretos.
          </p>
          <div className="grid grid-cols-2 gap-2" data-id="element-85">
            {[{
            icon: '📚',
            text: '6 Tomos de Coma Digital a Ejecutor'
          }, {
            icon: '🧠',
            text: 'Sin fuerza de voluntad requerida'
          }, {
            icon: '💰',
            text: 'Recuperá 4 horas diarias desde el día 1'
          }, {
            icon: '🛡️',
            text: 'Con protocolos biológicos reales'
          }].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm" data-id="element-86">
                <span className="text-lg" data-id="element-87">{item.icon}</span>
                <p className="text-gray-900 font-bold md:text-sm text-[10px]" data-id="element-88">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
});